// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// Turbolinks intercepts every same-origin link click. For same-path hash
// links its scroll-to-anchor uses the *cached* page snapshot, which on
// our React-rendered guide page doesn't have the heading IDs yet — so it
// falls back to scrolling to (0, 0). Cancel the interception entirely
// for hash-only clicks so the browser's native anchor scroll runs from
// the user's current position (with `scroll-behavior: smooth` applied).
//
// `turbolinks:click` fires *before* Turbolinks calls preventDefault on
// the click, so cancelling it leaves the browser default in place.
// (`turbolinks:before-visit` is too late — Turbolinks has already
// suppressed the browser's anchor scroll by then.)
document.addEventListener("turbolinks:click", (event) => {
  try {
    const target = new URL(event.data.url, location.href);
    if (
      target.origin === location.origin &&
      target.pathname === location.pathname &&
      target.search === location.search
    ) {
      event.preventDefault();
    }
  } catch (_) { /* malformed URLs fall through to default behavior */ }
});


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "controllers"
